import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header.jsx';
import Home from './components/Home.jsx';
import ServicePage from './components/ServicePage.jsx';
import Contact from './components/Contact.jsx';
import About from './components/About.jsx';
import LocationPage from './components/LocationPage.jsx';
import Footer from './components/Footer.jsx';
import ScrollToTop from './components/ScrollToTop.jsx';
import Blog from './components/Blog.jsx';
import BlogPost from './components/BlogPost.jsx';
import Estimators from './pages/Estimators.jsx';
import PressureWashing from './pages/PressureWashing.jsx';
import Residential from './pages/Residential.jsx';
import Commercial from './pages/Commercial.jsx';
import AboutTheAuthor from './pages/AboutTheAuthor.jsx';
import Pricing from './components/Pricing.jsx';
import FenceCleaning from './pages/FenceCleaning.jsx';
import SolarPanelCleaning from './pages/SolarPanelCleaning.jsx';
import PoolDeckCleaning from './pages/PoolDeckCleaning.jsx';
import GutterCleaning from './pages/GutterCleaning.jsx';
import DeckCleaning from './pages/DeckCleaning.jsx';
import GraffitiRemoval from './pages/GraffitiRemoval.jsx';
import WindowCleaning from './pages/WindowCleaning.jsx';
import SidewalkCleaning from './pages/SidewalkCleaning.jsx';
import PhoenixPowerWashing from './pages/PhoenixPowerWashing.jsx';
import ScottsdalePowerWashing from './pages/ScottsdalePowerWashing.jsx';
import MesaPowerWashing from './pages/MesaPowerWashing.jsx';
import TempePowerWashing from './pages/TempePowerWashing.jsx';
import GilbertPowerWashing from './pages/GilbertPowerWashing.jsx';
import ParadiseValleyPowerWashing from './pages/ParadiseValleyPowerWashing.jsx';
import DrivewayCleaning from './pages/DrivewayCleaning.jsx';
import PatioCleaning from './pages/PatioCleaning.jsx';
import CommercialConcreteCleaning from './pages/CommercialConcreteCleaning.jsx';

function App() {
  return (
    <HelmetProvider>
      <div className="min-h-screen bg-gray-100 flex flex-col">
        <Header />
        <ScrollToTop />
        <div className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/residential" element={<Residential />} />
            <Route path="/commercial" element={<Commercial />} />
            <Route path="/driveway-cleaning" element={<DrivewayCleaning />} />
            <Route path="/solar-panel-cleaning" element={<SolarPanelCleaning />} />
            <Route path="/pool-deck-cleaning" element={<PoolDeckCleaning />} />
            <Route path="/patio-cleaning" element={<PatioCleaning />} />
            <Route path="/commercial-concrete-cleaning" element={<CommercialConcreteCleaning />} />
            <Route path="/graffiti-removal" element={<GraffitiRemoval />} />
            <Route path="/window-cleaning" element={<WindowCleaning />} />
            <Route path="/gutter-cleaning" element={<GutterCleaning />} />
            <Route path="/sidewalk-cleaning" element={<SidewalkCleaning />} />
            <Route path="/deck-cleaning" element={<DeckCleaning />} />
            <Route path="/fence-cleaning" element={<FenceCleaning />} />
            <Route path="/phoenix-power-washing" element={<PhoenixPowerWashing />} />
            <Route path="/scottsdale-power-washing" element={<ScottsdalePowerWashing />} />
            <Route path="/mesa-power-washing" element={<MesaPowerWashing />} />
            <Route path="/tempe-power-washing" element={<TempePowerWashing />} />
            <Route path="/gilbert-power-washing" element={<GilbertPowerWashing />} />
            <Route path="/paradise-valley-power-washing" element={<ParadiseValleyPowerWashing />} />
            <Route path="/pressure-washing" element={<PressureWashing />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/about-the-author" element={<AboutTheAuthor />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </HelmetProvider>
  );
}

export default App;